export const isMMCCorrect = (question = {}, userAnswers = []) => {
  const { answers = [] } = question;

  const answersFormat = answers.map((answer) => String(answer));
  const lastUserAnswer = userAnswers[userAnswers.length - 1];

  return answersFormat.includes(String(lastUserAnswer));
};
